import React, { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
import { useParams } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


import { useDispatchReducerContext, useStateGettersContext } from '../../store';
import MetaInfo from './MetaInfo';
import { cb2Promise, useHandleAwsAuthErr } from '../../common/AwsUtil';
import ExecutionHistory from './ExecutionHistory';
import InfraArea from './InfraArea';

import infoBlackIcon from '../../assets/icons/info_black.png';
import useDeployEnv from './useDeployEnv';
import Cost from './Cost';
import ScanReport from './ScanReport';
import { CircularProgress, FormControlLabel } from '@material-ui/core';
import CheckBox from '@material-ui/core/Checkbox';
import useSkipTestEnv from './useSkipTestEnv';
import CommonButton2 from '../../components/ui/CommonButton2';
import ConfirmDialog from '../../components/ui/ConfirmDialog';
import { DISMISS_APP_LOADING, SHOW_APP_LOADING } from '../../store/dispatchNames';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '30px 70px'
    },
    title: {
        color: '#454545',
        fontSize: '22px',
        fontWeight: 700,
        paddingLeft: '8px',
        position: 'relative'
    },
    infraContainer: {
        marginTop: '28px'
    },
    executionTitleContainer: {
        marginTop: '28px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    executionTitle: {
        color: '#454545',
        fontSize: '22px',
        fontWeight: 600,
        padding: '8px 12px 12px 8px',
        display: 'inline-block',
        
    },
    executionInfo: {
        color: '#4D4E53',
        marginLeft: '12px',
        fontSize: '16px',
        fontWeight: 400,
        display: 'inline-block',
    },
    executionInfoIcon: {
        width: '18px',
        height: '18px',
        position: 'relative',
        top: '3px',
        paddingRight: '8px'
    },
    rightContainer: {
        display: 'inline-block',
        textAlign: 'right'
    },
    destroyContainer: {
        marginLeft: '20px',
        display: 'inline-block',
        position: 'relative'
    },
    rightContainerSplit: {
        position: 'absolute',
        display: 'block',
        background: '#E66400',
        width: '2px',
        top: '4px',
        bottom: '4px'
    },
    skipTestLoading: {
        margin: '13px 14px 13px 12px',
        color: '#E66400',
    },
    destroyTestEnvButton: {
        marginLeft: '20px',
        paddingRight: '10px',
        paddingLeft: '10px',
    }
}));

const CICDCheckbox = withStyles({
    root: {
        color: '#E66400',
        '&$checked': {
        color: '#E66400',
        },
    },
    checked: {},
})((props) => <CheckBox color="default" {...props} />);

const Project = () => {
    const classes = useStyles();
    const params = useParams();
    const storeGetters = useStateGettersContext();
    const handleAwsAuthErr = useHandleAwsAuthErr();

    const [pipelineOwner, setPipelineOwner] = useState("");
    const [projectShortName, setProjectShortName] = useState("");
    const [feature, setFeature] = useState(false);
    const [pipetype, setPipetype] = useState(null);
    const [projectName, setProjectName] = useState("");
    const [pipelineStages, setPipelineStages] = useState(null);
    const [isDataLakeAccount, setIsDataLakeAccount] = useState(false);
    const [isPipelineMetaLoading, setIsPipelineMetaLoading] = useState(false);
    const [isPipelineExist, setIsPipelineExist] = useState(true);
    const pipelineName = params.id;

    useEffect(() => {
        setIsPipelineExist(true);
        if (pipelineName) {
            let didMount = true;
            setIsPipelineMetaLoading(true);
            setPipelineOwner("");
            setProjectName("");
            setProjectShortName("");
            setIsDataLakeAccount(false);
            setFeature(false);
            setPipetype(null);
            const codepipeline = new AWS.CodePipeline(storeGetters.readonlyKeys);
            const params = {
                name: pipelineName
            };
            cb2Promise(codepipeline, 'getPipeline', params).then((data) => {
                setPipelineStages(data.pipeline.stages);
                let pipeLineArn = data.metadata.pipelineArn;
                var params = {
                    resourceArn: pipeLineArn
                };
                return cb2Promise(codepipeline, 'listTagsForResource', params);
            }).then((data) => {
                if (!didMount) return;
                data.tags.forEach(function (tag) {
                    if (tag.key === "Owner") {
                        setPipelineOwner(tag.value);
                    } else if (tag.key === "ProjectShortName") {
                        setProjectShortName(tag.value);
                    } else if ((tag.key === "dataLakeAccount" || tag.key === "DataLakeAccount") && tag.value === 'true') {
                        setIsDataLakeAccount(true);
                    } else if (tag.key === "Pipetype") {
                        setPipetype(tag.value);
                    } else if (tag.key === "Feature") {
                        setFeature(tag.value);
                    } else if (tag.key === "Name") {
                        setProjectName(tag.value);
                    }
                });

                setIsPipelineMetaLoading(false);
            }).catch((err) => {
                if (!didMount) return;
                if (!handleAwsAuthErr(err)) {
                    if (err.code === 'PipelineNotFoundException') {
                        setIsPipelineExist(false);
                    }
                }

                setIsPipelineMetaLoading(false);
            });

            return () => didMount = false;
        }
    }, [pipelineName, storeGetters.readonlyKeys, handleAwsAuthErr]);

    const {envExecutionIdMap, envVersionMap} = useDeployEnv(pipelineName, pipetype, pipelineOwner, pipelineStages, isDataLakeAccount, null, true);

    const [isShowConfirmDestroyTest, setIsShowConfirmDestroyTest] = useState(false);
    const { 
        hasSkipPermission, isSkipTestLoading, isSkipTestDeployment, handleSkipTestDeploymentChange, 
        isDisplayDestroyTestEnv, isDestroyTestEnvDisabled, isDestroyingTestEnv, destroyTestEnv, testEnvStackStatus
    } = useSkipTestEnv(projectName, pipelineOwner, projectShortName, pipetype);

    const dispatch = useDispatchReducerContext();
    const handleDestroyTestEnv = async () => {
        dispatch({
            type: SHOW_APP_LOADING
        });
        await destroyTestEnv();
        setIsShowConfirmDestroyTest(false);
        dispatch({
            type: DISMISS_APP_LOADING
        });
    }
    

    return <Box className={classes.container} >
        <Typography className={classes.title} variant="h2" >
            {
                isPipelineExist ? 'Pipeline Details' : `Pipeline ${pipelineName} is not exist or is creating...`
            }
        </Typography>
        {
            isPipelineExist && <>
                <Cost projectName={projectName} />
                <MetaInfo pipetype={pipetype} projectName={projectName} owner={pipelineOwner} isLoading={isPipelineMetaLoading} isDataLakeAccount={isDataLakeAccount} feature={feature}/>

                {!feature && 
                    <>
                        <ScanReport projectName={projectName} owner={pipelineOwner} />
                        <InfraArea projectShortName={projectShortName} pipelineOwner={pipelineOwner} pipetype={pipetype} />                   
                    </>
                }

                <Box className={classes.executionTitleContainer}>
                    <Box>
                        <Typography className={classes.executionTitle} variant="h2" >Pipeline Execution History</Typography>
                        <Typography className={classes.executionInfo} variant="caption" >
                            <img src={infoBlackIcon} alt='info' className={classes.executionInfoIcon} />It is showing only last one year's pipeline execution history.
                        </Typography>
                    </Box>


                    {!isDataLakeAccount && <Box className={classes.rightContainer}>
                        {
                            hasSkipPermission && <FormControlLabel
                                control={
                                    isSkipTestLoading ? 
                                        <CircularProgress className={classes.skipTestLoading} size={16} /> : 
                                        <CICDCheckbox checked={isSkipTestDeployment} onChange={handleSkipTestDeploymentChange} />
                                }
                                label="Skip Test Deployment: "
                                labelPlacement="start"
                            />
                        }
                        {
                            isDisplayDestroyTestEnv && <div className={classes.destroyContainer}>
                                <div className={classes.rightContainerSplit}></div>
                                <div title={testEnvStackStatus ? `Test env status: ${testEnvStackStatus}` : undefined}>
                                    <CommonButton2
                                        disabled={isDestroyTestEnvDisabled}
                                        loading={isDestroyingTestEnv}
                                        onClick={() => setIsShowConfirmDestroyTest(true)}
                                        className={classes.destroyTestEnvButton}
                                    >
                                        {
                                            isDestroyingTestEnv ? 'Destroying Test Env...' : ( isDestroyTestEnvDisabled ?'No Test Env' : 'Destroy Test Env')
                                        }
                                    </CommonButton2>
                                </div>
                            </div>
                        }
                    </Box>}
                </Box>
                <ExecutionHistory pipelineName={pipelineName} owner={pipelineOwner} envExecutionIdMap={envExecutionIdMap} envVersionMap={envVersionMap} pipetype={pipetype} />
                <ConfirmDialog
                    open={isShowConfirmDestroyTest}
                    onClose={() => setIsShowConfirmDestroyTest(false)}
                    title="If this component is having a bucket associated, please get these deleted first before attempting the test env clean up."
                    onConfirm={handleDestroyTestEnv}
                    confirmText="Delete"
                />
            </>
        }
    </Box>
}

export default Project;
